import { Redirect } from "react-router";

interface Props {
  defaultUrl?: string;
  redirectTo?: string | (string | null)[] | null;
}

const getURL = ({ defaultUrl, redirectTo }: Props) => {
  if (redirectTo && !Array.isArray(redirectTo)) {
    // Decode url params, so we get encoded values. Ex: in company-register page via chargebee
    return decodeURIComponent(redirectTo);
  }

  if (defaultUrl) {
    return defaultUrl;
  }

  return "/";
};

const LandingPage = (props: Props): JSX.Element => {
  const url = getURL(props);

  return <Redirect exact to={url} />;
};

export default LandingPage;
